import React from 'react'


const data = [
    {
      name: "Aubrey Bomela",
      job: "Electrical Engineer",
      company: "Shivam Electricals Pvt Ltd",
      schedule: "Jun 1, 2024",
      status: "Scheduled",
      remark: "DD",
    },
    {
      name: "Usman Shaikh",
      job: "Quality Engineer",
      company: "Shivam Electricals Pvt Ltd",
      schedule: "Dec 7, 2023",
      status: "Scheduled",
      remark: "Re",
    },
    {
      name: "Nida Waja",
      job: "Quality Engineer",
      company: "Shivam Electricals Pvt Ltd",
      schedule: "Dec 7, 2023",
      status: "Inprocess",
      remark: "Remember",
    },
    {
        name: "Aubrey Bomela",
        job: "Electrical Engineer",
        company: "Shivam Electricals Pvt Ltd",
        schedule: "Jun 1, 2024",
        status: "Scheduled",
        remark: "DD",
      },
      {
        name: "Usman Shaikh",
        job: "Quality Engineer",
        company: "Shivam Electricals Pvt Ltd",
        schedule: "Dec 7, 2023",
        status: "Scheduled",
        remark: "Re",
      },
      {
        name: "Nida Waja",
        job: "Quality Engineer",
        company: "Shivam Electricals Pvt Ltd",
        schedule: "Dec 7, 2023",
        status: "Inprocess",
        remark: "Remember",
      },
  ];
   
const Approval = () => {

  return (
    <>
    
    <section className="pricing-section-three ApprovalProcess">
      <div className="container st3">
        <div className="row">
          <div className="col-lg-12">
              <h4>Schedules</h4>
              <div className="table-res">
                  <table className="schedule-table">
                    <thead>
                      <tr>
                        <th>Candidates Name</th>
                        <th>Job Description</th>
                        <th>Schedule</th>
                        <th>Status</th>
                        <th>Remark</th>
                        <th>CV</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <div className="candidate-info">
                              <img
                                src={`https://via.placeholder.com/50`}
                                alt="avatar"
                                className="avatar"
                              />
                              <span>{item.name}</span>
                            </div>
                          </td>
                          <td>
                            {item.job}
                            <br />
                            <span className="company">{item.company}</span>
                          </td>
                          <td>{item.schedule}</td>
                          <td>
                            <select defaultValue={item.status}>
                              <option value="Scheduled">Scheduled</option>
                              <option value="Inprocess">Inprocess</option>
                              <option value="Completed">Completed</option>
                            </select>
                          </td>
                          <td>{item.remark}</td>
                          <td>
                            <button className="cv-button">📄</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
              </div>
          </div>
         </div>
        </div>
      {/* </div> */}
    </section>

    </>
  )
}

export default Approval